import React, { useState } from 'react';

import { WpMenu, WpMenuItem, WpMenuDivider } from '..';

const MenuDocs = () => {
  const [active, setActive] = useState('one');
  return (
    <>
      <WpMenu activeItemId={active} onMenuItemClick={setActive}>
        <WpMenuItem menuItemId="one">One</WpMenuItem>
        <WpMenuItem menuItemId="two">Two</WpMenuItem>
        <WpMenu>
          <WpMenuItem menuItemId="two-1">Two - 1</WpMenuItem>
          <WpMenuItem menuItemId="two-2">Two - 2</WpMenuItem>
          <WpMenuItem menuItemId="two-3">Two - 3</WpMenuItem>
        </WpMenu>
        <WpMenuItem menuItemId="three">Three</WpMenuItem>
        <WpMenuDivider />
        <WpMenuItem menuItemId="four">Four</WpMenuItem>
        <WpMenuItem menuItemId="five">Five</WpMenuItem>
      </WpMenu>
    </>
  );
};

export default MenuDocs;
